import { useMemo } from "react";

import { DatabaseMetadataPopover } from "../../../../components/DatabaseMetadataPopover/DatabaseMetadataPopover.tsx";
import Spoiler from "../../../../components/Spoiler/Spoiler.tsx";
import {
  RiskMonitoringRemarks,
  toHumanReadableCustomerRiskRecommendation,
} from "../../../../types/customer.ts";
import { booleanToString } from "../../../../utils/boolean.ts";

interface Props {
  data: RiskMonitoringRemarks | null | undefined;
}

export const useRiskMonitoringCard = ({ data }: Props) => {
  return useMemo(() => {
    return [
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "RiskMonitoringRemarks",
              fieldName: "priceAdjustment",
            }}
            position="right"
          >
            Price Adjustment
          </DatabaseMetadataPopover>
        ),
        content: booleanToString(data?.priceAdjustment, "display"),
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "RiskMonitoringRemarks",
              fieldName: "riskRecommendation",
            }}
            position="right"
          >
            Risk Recommendation
          </DatabaseMetadataPopover>
        ),
        content: toHumanReadableCustomerRiskRecommendation(
          data?.riskRecommendation
        ),
      },
      {
        label: (
          <DatabaseMetadataPopover
            databaseMetadata={{
              tableName: "RiskMonitoringRemarks",
              fieldName: "notes",
            }}
            position="right"
          >
            Remarks
          </DatabaseMetadataPopover>
        ),
        content: data?.notes && (
          <Spoiler maxStringLength={300} text={data.notes} />
        ),
      },
    ];
  }, [data]);
};
